"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "createCache", {
    enumerable: true,
    get: function() {
        return createCache;
    }
});
const _cache = require("@lage-run/cache");
const _isRunningFromCI = require("./isRunningFromCI.js");
async function createCache(options) {
    const { cacheOptions, logger, root, skipLocalCache } = options;
    const hasRemoteCacheConfig = !!cacheOptions?.cacheStorageConfig || !!process.env.BACKFILL_CACHE_PROVIDER || !!process.env.BACKFILL_CACHE_PROVIDER_OPTIONS;
    // Create Cache Provider
    const cacheProvider = new _cache.RemoteFallbackCacheProvider({
        root,
        logger,
        localCacheProvider: skipLocalCache === true ? undefined : new _cache.BackfillCacheProvider({
            logger,
            root,
            cacheOptions: {
                outputGlob: cacheOptions?.outputGlob,
                ...cacheOptions?.internalCacheFolder && {
                    internalCacheFolder: cacheOptions.internalCacheFolder
                },
                ...cacheOptions?.incrementalCaching && {
                    incrementalCaching: cacheOptions.incrementalCaching
                }
            }
        }),
        remoteCacheProvider: hasRemoteCacheConfig ? new _cache.BackfillCacheProvider({
            logger,
            root,
            cacheOptions: cacheOptions ?? {}
        }) : undefined,
        writeRemoteCache: (cacheOptions?.writeRemoteCache === true || String(process.env.LAGE_WRITE_CACHE).toLowerCase() === "true" || _isRunningFromCI.isRunningFromCI) && String(process.env.LAGE_WRITE_CACHE).toLowerCase() !== "false"
    });
    return {
        cacheProvider
    };
}
